"use client";
import Link from "next/link";
import Image from "next/image";
const PageBanner = ({ pageTitle, pageName }) => {
  return (
    <div className="mil-banner-sm mil-deep-bg">
      <Image
        src="/img/theme/map.png"
        alt="background"
        priority={true}
        className="mil-background-image"
        fill
      />
      <div
        className="mil-deco mil-deco-accent"
        style={{ top: "47%", right: "10%", transform: "rotate(90deg)" }}
      />
      <div className="mil-banner-content">
        <div className="container mil-relative">
          <ul className="mil-breadcrumbs mil-mb-30 p-0">
            <li>
              <Link href="/">Home</Link>
            </li>
            <li>
              <Link href="#">{pageName}</Link>
            </li>
          </ul>
          <h2 className="mil-uppercase mil-h2" style={{marginTop:'2.5rem'}}>{pageTitle}</h2>
        </div>
      </div>
    </div>
  );
};
export default PageBanner;
